import React, { useState } from "react";
import { Edit, X, CheckCircle, AlertCircle } from "lucide-react";
import axios from "axios";

function FollowUpNotesForm({ lead_id }) {
  const [nextFollowUpDate, setNextFollowUpDate] = useState("");
  const [followUpAction, setFollowUpAction] = useState("");
  const [notes, setNotes] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [responseMessage, setResponseMessage] = useState("");
  const [responseType, setResponseType] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [user] = useState(JSON.parse(sessionStorage.getItem("user")));

  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      const response = await axios.post(`${BASE_URL}/leads/addLeadsFollowup`, {
        lead_id,
        user_id: user?.id,
        followup_date: nextFollowUpDate,
        followup_action: followUpAction,
        notes,
      });
      setNextFollowUpDate("");
      setFollowUpAction("");
      setNotes("");
      setResponseMessage("Follow-up updated successfully!");
      setResponseType("success");
      console.log("Response:", response.data);
    } catch (error) {
      setResponseMessage("Failed to update follow-up.");
      setResponseType("error");
      console.error("Error submitting follow-up:", error);
    } finally {
      setIsSubmitting(false);
      setShowModal(true);
    }
  };
  return (
    <div className="flex items-center justify-center">
      <div className="w-full max-w-2xl bg-white rounded-xl shadow-lg p-6 space-y-6">
        <h2 className="text-2xl font-semibold text-gray-900">
          Follow-up & Notes
        </h2>

        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Next Follow-up Date
            </label>
            <input
              type="datetime-local"
              value={nextFollowUpDate}
              onChange={(e) => setNextFollowUpDate(e.target.value)}
              className="block w-full rounded-lg border border-gray-300 px-4 py-3 focus:border-blue-500 focus:outline-none focus:ring-blue-500 transition-colors"
              required
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Follow-up Action
            </label>
            <select
              value={followUpAction}
              onChange={(e) => setFollowUpAction(e.target.value)}
              className="block w-full rounded-lg border border-gray-300 px-4 py-3 focus:border-blue-500 focus:outline-none focus:ring-blue-500 transition-colors"
              required
            >
              <option value="">Select a follow up action</option>
              <option value="New">New</option>
              <option value="Contacted">Contacted</option>
              <option value="Interested">Interested</option>
              <option value="Not Interested">Not Interested</option>
              <option value="Follow-Up Needed">Follow-Up Needed</option>
              <option value="MQL (Marketing Qualified Lead)">
                MQL (Marketing Qualified Lead)
              </option>
              <option value="SQL (Sales Qualified Lead)">
                SQL (Sales Qualified Lead)
              </option>
              <option value="Site Visit Scheduled by Ailaa AI">
                Site Visit Scheduled by Ailaa AI
              </option>
              <option value="Site Visit Scheduled by Telecaller/ Sales Team">
                Site Visit Scheduled by Telecaller/ Sales Team
              </option>
              <option value="Proposal Sent">Proposal Sent</option>
              <option value="Negotiation">Negotiation</option>
              <option value="Converted">Converted</option>
              <option value="Closed - Lost">Closed - Lost</option>
              <option value="Closed - Won">Closed - Won</option>
              <option value="No Response">No Response</option>
              <option value="Disqualified">Disqualified</option>
            </select>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Notes
            </label>
            <textarea
              value={notes}
              onChange={(e) => setNotes(e.target.value)}
              rows={4}
              className="block w-full rounded-lg border border-gray-300 px-4 py-3 focus:border-blue-500 focus:outline-none focus:ring-blue-500 transition-colors"
              required
            />
          </div>

          <button
            type="submit"
            disabled={isSubmitting}
            className="w-full flex items-center justify-center px-4 py-3 border border-transparent rounded-lg shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
          >
            <Edit className="w-5 h-5 mr-2" />
            {isSubmitting ? "Updating..." : "Update Follow-up"}
          </button>
        </form>

        {showModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg p-8 max-w-md w-full mx-4">
              <div className="flex justify-between items-center mb-6">
                <h3 className="text-xl font-semibold text-gray-900">
                  {responseType === "success" ? "Success!" : "Error"}
                </h3>
                <button
                  onClick={() => setShowModal(false)}
                  className="text-gray-400 hover:text-gray-500 transition-colors"
                >
                  <X className="h-6 w-6" />
                </button>
              </div>

              <div className="flex items-center justify-center mb-6">
                <div
                  className={`rounded-full p-3 ${
                    responseType === "success" ? "bg-green-100" : "bg-red-100"
                  }`}
                >
                  {responseType === "success" ? (
                    <CheckCircle className="h-8 w-8 text-green-500" />
                  ) : (
                    <AlertCircle className="h-8 w-8 text-red-500" />
                  )}
                </div>
              </div>

              <p className="text-center text-gray-600 mb-6">
                {responseMessage}
              </p>

              <button
                onClick={() => setShowModal(false)}
                className="w-full px-4 py-3 text-white bg-blue-600 hover:bg-blue-700 rounded-lg transition-colors"
              >
                {responseType === "success" ? "Close" : "Try Again"}
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default FollowUpNotesForm;
